export default __webpack_public_path__ + "static/media/cornerLogo.f9fda7eb.svg";